module.exports = __webpack_public_path__ + "img/green-mark.e8836427.svg";